import React, { Fragment } from "react"
import styled from "react-emotion"
import Icon from "ui/components/Icon"

const NumberIcon = styled("span")`
    font-size: 15px;
    font-weight: 900;
    padding: 6px;
    font-face: Arial Black; Helvetica, Arial;
    letter-spacing: -2px;
`

export default [
    {
        label: "Text",
        icon: <Icon icon="font" />,
        value: "string",
    },
    {
        label: "Long Text",
        icon: <Icon icon="align-left" />,
        value: "long_text",
    },
    // {
    //     label: (
    //         <Fragment>
    //             Rich Text
    //         </Fragment>
    //     ),
    // icon: <Icon icon="newspaper" />
    //     value: "rich_text",
    // },
    {
        label: "Number",
        icon: <NumberIcon>123</NumberIcon>,
        value: "integer",
    },
    // {
    //     label: (
    //         <Fragment>
    //              />Currency
    //         </Fragment>
    //     ),
    // icon: <Icon icon="dollar-sign"
    //     value: "currency",
    // },
    {
        label: "Link to another record",
        icon: <Icon icon="link" />,
        value: "lookup",
    },
    {
        label: "Web URL",
        icon: <Icon icon="external-link" />,
        value: "url",
    },
    {
        label: "Image",
        icon: <Icon icon="image" />,
        value: "image",
    },
    {
        label: "Date",
        icon: <Icon icon="calendar-alt" />,
        value: "date",
    },
    {
        label: "Checkbox",
        icon: <Icon icon="check-square" />,
        value: "checkbox",
    },
    {
        label: "Dropdown",
        icon: <Icon icon="caret-square-down" />,
        value: "dropdown",
    },
]



// WEBPACK FOOTER //
// ./src/features/studio/utils/fieldTypes.js